import React from "react";
import classnames from "classnames";
import { TransitionGroup } from "react-transition-group";
import VideoModal from "../modal/VideoModal";
import Play from "-!svg-react-loader!../../assets/Icon_Play2.svg";
// import CloseIcon from '-!svg-react-loader!../../assets/Close_X.svg';
/* eslint import/no-webpack-loader-syntax: off */

import styles from "./Details.styl";

function upperCaseString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      showVideoModal: false
    };

    this.handleRotateImages = this.handleRotateImages.bind(this);
    this.openVideoModal = this.openVideoModal.bind(this);
    this.closeVideoModal = this.closeVideoModal.bind(this);
  }

  componentWillMount() {
    this.setState({
      images: this.props.animal.images
    });
  }

  rotate(array, stepsToShift) {
    for (var i = 0; i < stepsToShift; i++) {
      array.unshift(array.pop());
    }

    return array;
  }

  handleRotateImages = steps => {
    let rotatedImages = [];
    if (this.props.animal.images.length === 2) {
      rotatedImages = this.state.images.reverse();
    } else {
      rotatedImages = this.rotate(this.state.images, steps);
    }
    this.setState({
      images: rotatedImages
    });
  };

  openVideoModal = () => {
    this.setState({
      showVideoModal: true
    });
  };

  closeVideoModal = () => {
    this.setState({
      showVideoModal: false
    });
  };

  render() {
    let animal = this.props.animal;

    return (
      <div className={styles.detailsContainer}>
        <TransitionGroup>
          {this.state.showVideoModal && (
            <VideoModal
              url={this.state.images[0].videoUrl}
              closeModal={this.closeVideoModal}
            />
          )}
        </TransitionGroup>
        <div className={styles.detailsRow}>
          <div
            className={styles.animalImage}
            style={{
              backgroundImage: `url(${this.state.images[0].url})`
            }}
          >
            {this.state.images[0].attributionName && (
              <a
                href={this.state.images[0].attributionUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.attribution}
              >
                {`Ⓒ ${this.state.images[0].attributionName}`}
              </a>
            )}
            {this.state.images[0].type === "video" && (
              <Play
                height={70}
                width={70}
                className={styles.playIcon}
                onClick={this.openVideoModal}
              />
            )}
          </div>
          <div className={styles.infoBox}>
            <h1 className={styles.animalName}>
              {animal.name}
              <span>, {upperCaseString(animal.name2)}</span>
            </h1>
            {animal.protectedSince ? (
              <div className={styles.infoRow}>
                <div className={styles.infoCol}>
                  <h3>{animal.protectedSince}</h3>
                  <p>Protected Since</p>
                </div>
                <div className={styles.infoCol}>
                  <h3>{animal.status}</h3>
                  <p>Status</p>
                </div>
              </div>
            ) : (
              <div className={styles.infoRow}>
                <div className={classnames(styles.infoCol, styles.full)}>
                  <h3>{animal.status}</h3>
                  <p>Status</p>
                </div>
              </div>
            )}

            <div className={styles.infoParagraph}>
              <p>{animal.details}</p>
            </div>
            {animal.ambassador ? (
              <div className={styles.ambassador}>
                Celebrity Ambassador: <span>{animal.ambassador}</span>
              </div>
            ) : (
              ""
            )}
            <div className={styles.imageRow}>
              {this.state.images[1] && (
                <div className={styles.imageCol}>
                  <div
                    className={styles.thumbnail}
                    style={{
                      backgroundImage: `url(${this.state.images[1].url})`
                    }}
                    onClick={() => this.handleRotateImages(2)}
                  />
                </div>
              )}
              {this.state.images[2] && (
                <div className={styles.imageCol}>
                  <div
                    className={styles.thumbnail}
                    style={{
                      backgroundImage: `url(${this.state.images[2].url})`
                    }}
                    onClick={() => this.handleRotateImages(1)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Details;



// WEBPACK FOOTER //
// ./src/components/carousel/Details.js